import React, { useState, useEffect } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { isEqual, isEmpty } from 'lodash'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { ReactComponent as CheckIcon } from 'assets/img/check-icon.svg'
import { FormControl, Button } from '@material-ui/core'
import messages from '../../translate'
import { StyledFormControl, Label, StyledButton } from './JobImagesInput.styles'
import ImagesList from './ImagesList'

function JobImagesInput({
  inputInfo: { id, parameters, title, required },
  inputData,
  onJobTaskAutoSave,
  options,
  intl: { formatMessage },
  disabled,
}) {
  const [value, setValue] = useState({})
  const [evtTaskInputId, setEvtTaskInputId] = useState('')
  const [isUpdating, setIsUpdating] = useState(false)

  const getItemDataObject = () => {
    if (!inputData.value) return

    const arrayValue = Array.isArray(inputData.value)
      ? inputData.value
      : [inputData.value]
    let data = {}

    arrayValue.forEach(item => {
      const { itemTitle = item } = options[item]

      data = { ...data, [item]: itemTitle }
    })

    return data
  }

  useEffect(() => {
    let formattedValue = {}

    if (!isEmpty(value)) {
      return
    }

    if (!isEmpty(inputData.value)) {
      formattedValue = getItemDataObject()
    }

    setValue(formattedValue)
    setEvtTaskInputId(inputData.evtInputId)
  }, [inputData.evtInputId])

  const onInputSave = savedValue => {
    const itemValueKeys = Object.keys(savedValue)
    const itemValues = !isEmpty(savedValue) ? itemValueKeys : []
    const formattedValue = parameters.multiple
      ? itemValues
      : itemValueKeys[0] || null

    setIsUpdating(true)

    onJobTaskAutoSave(
      {
        evtInputId: inputData.evtInputId || evtTaskInputId,
        result: formattedValue,
        input: id,
        setResultId: result => {
          setEvtTaskInputId(result.id)
        },
      },
      () => {
        setIsUpdating(false)
      },
    )
  }

  const multiSelection = itemData => {
    const [itemValue] = Object.keys(itemData)
    const valueExist =
      !isEmpty(value) && Object.prototype.hasOwnProperty.call(value, itemValue)
    let newValue = { ...value }

    if (valueExist) {
      delete newValue[itemValue]
    } else {
      newValue = { ...value, ...itemData }
    }

    return newValue
  }

  const onItemClick = itemData => {
    const singleSelectValue = isEqual(value, itemData) ? {} : itemData
    const formattedValue = parameters.multiple
      ? multiSelection(itemData)
      : singleSelectValue

    setValue(formattedValue)

    if (!parameters.multiple) {
      onInputSave(formattedValue)
    }
  }

  const onMultiInputSave = () => {
    if (parameters.multiple) {
      onInputSave(value)
    }
  }

  const arrayItemValue =
    !isEmpty(inputData) && Array.isArray(inputData.value) && inputData.value
  const compareValues =
    arrayItemValue &&
    value &&
    isEqual(Object.keys(value).sort(), arrayItemValue.sort())
  const drawAsterisk = required ? '*' : ''
  const isInputDisabled = disabled || isUpdating
  const horizontalScrollCondition =
    ifWindowWidthLessThan(TABLET_BREAKPOINT) &&
    !isEmpty(value) &&
    Object.keys(options).length > 2
  const onSaveImagesButton = (
    <StyledButton>
      <Button
        href={null}
        disabled={isInputDisabled || compareValues}
        variant="contained"
        color="primary"
        onClick={onMultiInputSave}>
        <FormattedMessage {...messages.apply} />
      </Button>
    </StyledButton>
  )

  return (
    <StyledFormControl>
      <FormControl>
        <Label justify="space-between">
          <span>
            {title} {drawAsterisk}
          </span>
          {horizontalScrollCondition && (
            <span>
              <CheckIcon /> {formatMessage(messages.chosen)}
            </span>
          )}
        </Label>
        <ImagesList
          value={value}
          onItemClick={onItemClick}
          options={options}
          isMultiple={parameters.multiple}
          disabled={disabled}
        />
        {parameters.multiple && onSaveImagesButton}
      </FormControl>
    </StyledFormControl>
  )
}

export default injectIntl(JobImagesInput)
